export default __webpack_public_path__ + "static/media/settings.dba99de8.svg";